import { makeStyles, Theme } from "@material-ui/core/styles";
import { emphasize } from "@material-ui/core/styles/colorManipulator";

export const useStyles = makeStyles<
  Theme,
  { isDisabled: boolean; isMulti: boolean; margin: string }
>(({ spacing, palette }: Theme) => ({
  input: props => ({
    display: "flex",
    paddingTop: 0,
    paddingBottom: 0,
    minHeight: props.margin === "dense" ? "37.63px" : "53.63px",
    margin: 0,
    height: "auto",
    minWidth: "100px"
  }),
  valueContainer: props => ({
    display: "flex",
    flexWrap: (props.isMulti ? "wrap" : "nowrap") as any,
    overflow: "hidden",
    flex: "auto",
    alignItems: "center",
    cursor: "pointer",
    "& > p": {
      overflow: "hidden",
      textOverflow: "ellipsis"
    }
  }),
  textField: props => ({
    "& > label": {
      color: props.isDisabled ? palette.grey[500] : palette.grey[700]
    }
  }),
  chip: {
    margin: spacing(0.5, 0.25)
  },
  chipFocused: {
    backgroundColor: emphasize(
      palette.type === "light" ? palette.grey[300] : palette.grey[700],
      0.08
    )
  },
  noOptionsMessage: {
    padding: spacing(1, 2)
  },
  singleValue: {},
  disabledValue: {
    color: palette.grey[500]
  },
  placeholder: {
    color: palette.grey[500],
    position: "absolute",
    fontStyle: "italic"
  },
  paper: {
    position: "absolute",
    zIndex: 100,
    marginTop: spacing(),
    left: 0,
    right: 0
  },
  dropDownIcon: {
    fontSize: "1.5rem"
  },
  helperText: {
    margin: "4px 12px 4px"
  },
  option: {}
}));
